import React, { useEffect, useState } from 'react';
import "./slide.css";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Divider } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../helper';
import Skeleton from '@mui/material/Skeleton';

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1
  }
};

export default function Slide({ title }) {
  const [productData, setProductData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      const response = await fetch(`${BASE_URL}/api/productdata`, {
        method: "POST",
        headers: {
          'Content-type': 'application/json'
        }
      });

      if (response.ok) {
        const data = await response.json();
        setProductData(data);
        setLoading(false);
      } else {
        console.error("Failed to fetch product data");
      }
    } catch (error) {
      console.error("Error fetching product data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onClickGetItem = (postId) => {
    navigate(`/getcartitem/${postId}`); // Pass postId as a parameter in URL
  };

  return (
    <div className="products_section">
      <div className="products_deal">
        <h3>{title}</h3>
        <button className="view_btn">View All</button>
      </div>
      <Divider />

      <Carousel
        responsive={responsive}
        infinite={true}
        draggable={false}
        swipeable={true}
        centerMode={true}
        autoPlay={true}
        autoPlaySpeed={4000}
        keyBoardControl={true}
        showDots={false}
        removeArrowOnDeviceType={["tablet", "mobile"]}
        dotListClass="custom-dot-list-style"
        itemClass="carousel-item-padding-40-px"
        containerClass="carousel-container"
      >
        {loading ? (
          Array.from(new Array(4)).map((_, index) => (
            <div className="products_items" key={index}>
              <Skeleton variant="rectangular" width={200} height={200} />
              <Skeleton width="80%" style={{ marginTop: '1rem' }} />
              <Skeleton width="50%" style={{ marginTop: '0.5rem' }} />
              <Skeleton width="60%" style={{ marginTop: '0.5rem' }} />
            </div>
          ))
        ) : (
          productData.map((pdata) => (
            <div className="products_items" key={pdata.id}>
              <div className="product_img">
                <img onClick={() => onClickGetItem(pdata.id)} src={pdata.url} alt="product" />
              </div>
              <p className="products_name">
                {pdata.title.shortTitle}
              </p>
              <p className="products_offer" style={{ color: "#007185" }}>
                {pdata.discount}
              </p>
              <p className="products_explore">{pdata.tagline}</p>
            </div>
          ))
        )}
      </Carousel>
    </div>
  )
}
